// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"696":"29046ad685444e73","2888":"020514b48b3e2254","6161":"773f208bbd3fbdcb"}[chunkId] + ".css";
};